import { Eole } from "@syadem/eole";
import { parseEoleCalendarConfig } from "../domain/parseEoleCalendarConfig";
import { AppStore } from "../store";

export class GetPublicConfigsQuery {
  constructor(
    private readonly eole: Eole,
    private readonly store: AppStore,
  ) {}

  async call(): Promise<void> {
    try {
      const apiPublicConfigs = await this.eole.publicConfigs();
      const publicConfigs = apiPublicConfigs.map(parseEoleCalendarConfig);

      this.store.setState((state) => ({
        ...state,
        publicConfigs,
      }));
    } catch (e) {
      console.error(e);
    }
  }
}
